<template>
    <Overlay :show="showLoading">
        <b-modal
            ref="selectUserInterfaceModal"
            cancel-variant="outline-secondary"
            cancel-title="Close"
            centered
            no-close-on-backdrop
            title="Select user interface"
        >
            <b-form-group
                :label="$t('Component(Label):operations')"
                label-for="categories"
            >
                <v-select
                    v-model="userInterfaces"
                    multiple
                    id="categories"
                    label="title"
                    :placeholder="$t('Component(Placeholder):operations')"
                    :options="allUserInterfaces"
                />
            </b-form-group>
        </b-modal>
        <b-row>
            <b-col>
                <h2>
                    {{ id ? 'Edit ' + service.title : 'Create new service' }}
                </h2>
            </b-col>
            <b-col class="pb-2">
                <CreateUpdateServiceActions
                    class="float-right"
                    @save="save"
                    @close="close"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6" lg="6">
                <b-card title="General info">
                    <validation-observer ref="generalInfo">

                        <b-form-group :label="$t('Component(Label):parent')">
                            <treeselect
                                @input="onParentChange"
                                :options="hierarchy"
                                noChildrenText=""
                                valueFormat="object"
                                :normalizer="normalize"
                                v-model="service.parent"
                                :placeholder="$t('Component(Placeholder):parent')"
                            />
                        </b-form-group>

                        <b-tabs>
                            <b-tab
                                v-for="language in languages"
                                :title="language.code.toUpperCase()"
                            >
                                <b-form-group
                                    :label="$t('Component(Label):name')"
                                    :label-for="'name' + language.code"
                                >
                                    <validation-provider
                                        #default="{ errors }"
                                        :name="language.title + ' ' + $t('Component(Label):name')"
                                        rules="required"
                                    >
                                        <b-form-input
                                            :state="errors.length > 0 ? false:null"
                                            id="name"
                                            v-model="service.translations[language.code].title"
                                            :placeholder="$t('Component(Placeholder):name')"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group
                                    :label="$t('Component(Label):description')"
                                    :label-for="'description' + language.code"
                                >
                                    <validation-provider
                                        #default="{ errors }"
                                        :name="language.title + ' ' + $t('Component(Label):description')"
                                    >
                                        <b-form-textarea
                                            :state="errors.length > 0 ? false:null"
                                            type="text"
                                            v-model="service.translations[language.code].description"
                                            rows="2"
                                            max-rows="6"
                                            :placeholder="$t('Component(Placeholder):description')"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group
                                    :label="$t('Component(Label):technical-description')"
                                    :label-for="'technical-description' + language.code"
                                >
                                    <validation-provider
                                        #default="{ errors }"
                                        :name="language.title + ' ' + $t('Component(Label):technical-description')"
                                    >
                                        <b-form-textarea
                                            :state="errors.length > 0 ? false:null"
                                            type="text"
                                            v-model="service.translations[language.code].technicalDescription"
                                            rows="2"
                                            max-rows="6"
                                            :placeholder="$t('Component(Placeholder):technical-description')"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-tab>
                        </b-tabs>
                    </validation-observer>
                </b-card>
            </b-col>
            <b-col md="6" lg="6">
                <b-card title="Application">
                    <b-form-group
                        :label="$t('Component(Label):applications')"
                        label-for="applications"
                    >
                        <v-select
                            v-model="service.applications"
                            multiple
                            id="applications"
                            :placeholder="$t('Component(Placeholder):applications')"
                            :options="applications"
                        />
                    </b-form-group>
                </b-card>
                <b-card title="Operations">
                    <b-form-group
                        :label="$t('Component(Label):operations')"
                        label-for="categories"
                    >
                        <v-select
                            v-model="service.operations"
                            multiple
                            id="categories"
                            label="name"
                            :placeholder="$t('Component(Placeholder):operations')"
                            :options="operations"
                        />
                    </b-form-group>
                </b-card>
                <b-card title="User interfaces">
                    <b-form-group
                        :label="$t('Component(Label):user-interfaces')"
                        label-for="user-interfaces"
                    >
                        <v-select
                            v-model="userInterfaces"
                            multiple
                            id="user-interfaces"
                            label="title"
                            :placeholder="$t('Component(Placeholder):user-interfaces')"
                            :options="allUserInterfaces"
                        />
                    </b-form-group>
                </b-card>
            </b-col>
        </b-row>
<!--        <b-row>-->
<!--            <b-col>-->
<!--                <HamletTable-->
<!--                    @created="saveUserInterfacesTableConfig"-->
<!--                    :columns="uiColumns"-->
<!--                    :fetch="fetchUserInterfaces"-->
<!--                >-->
<!--                    <template #header-controls>-->
<!--                        <Button class="btn-icon" @click="selectUserInterface"><feather-icon icon="PlusIcon"/></Button>-->
<!--                    </template>-->

<!--                    <template #header-label>-->
<!--                        {{ $t('Page(ServiceCard):Component(Text):user-interfaces') }}-->
<!--                    </template>-->
<!--                </HamletTable>-->
<!--            </b-col>-->
<!--        </b-row>-->
        <b-row>
            <b-col>
                <CreateUpdateServiceActions
                    class="float-right"
                    @save="save"
                    @close="close"
                />
            </b-col>
        </b-row>
    </Overlay>
</template>

<script>
import Overlay from "@core/components/common/Overlay";
import {BRow, BCol, BCard, BFormTextarea, BFormGroup, BFormInput, BTabs, BTab, BModal} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Treeselect from '@riophae/vue-treeselect'
import {Button} from "@core/components/common";
import {i18nApi, SystemApi} from "@core/api";
import backendResponse from "@core/mixins/ui/backend-response";
import {required} from '@validations'
import vSelect from 'vue-select'
import CreateUpdateServiceActions from "@/views/system/Security/components/CreateUpdateServiceActions";
import HamletTable from "@core/components/common/HamletTable";
import {Application} from "@/libs/application";

export default {
    mixins: [backendResponse],
    components: {
        Overlay, BRow, BCol, ValidationProvider, ValidationObserver, BCard, BFormTextarea, BFormGroup, BFormInput,
        Treeselect, vSelect, CreateUpdateServiceActions, BTabs, BTab, HamletTable, BModal, Button
    },
    props: {
        id: {
            default: null
        }
    },
    data() {
        return {
            showLoading: true,
            service: {
                title: '',
                description: '',
                technicalDescription: '',
                parent: null,
                operations: [],
                applications: []
            },
            uiColumns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'type',
                    label: this.$t('Component(Grid):column-type')
                }
            ],
            userInterfaceToAdd: null,
            allUserInterfaces: [],
            languages: [],
            hierarchy: [],
            operations: [],
            userInterfaces: [],
            applications: Application.all(),
            // userInterfaces: {items: []},
            uiConfig: null,
            uiCb: null,
            required
        }
    },
    methods: {
        gatherSaveAttributes() {

            return {
                ...this.service,
                parent: this.service.parent ? this.service.parent.id : null
            };
        },
        save() {
            this.$refs.generalInfo.validate().then(isValid => {
                if (isValid) {
                    if (this.id) {
                        SystemApi.services
                            .save(this.id, this.gatherSaveAttributes(), this.userInterfaces)
                            .then(r => {
                                this.showDefaultSuccessMessage('Service has been successfully updated!');
                            })
                            .catch(this.handleBackendError);
                    } else {
                        SystemApi.services
                            .create(this.gatherSaveAttributes(), this.userInterfaces)
                            .then(r => this.close())
                            .catch(this.handleBackendError);
                    }
                }
            });
        },
        close() {
            this.$router.go(-1);
        },
        selectUserInterface() {
            this.$refs.selectUserInterfaceModal.show();
        },
        normalize(node) {
            return {id: node.id, label: node.title};
        },
        onParentChange() {

        },
        disableCurrentNode(children) {
            if (null === this.id) {
                return;
            }
            let disabled = false;
            children.forEach(child => {
                if (parseInt(child.id) === parseInt(this.id)) {
                    child.isDisabled = true;
                    disabled = true;
                    child.children = [];
                }

                if (false === disabled) {
                    this.disableCurrentNode(child.children);
                }
            });
        },
        fetchUserInterfaces(config, cb) {
            cb(
                this.userInterfaces.length,
                this.userInterfaces.slice(config.page * config.perPage - config.perPage, config.page * config.perPage)
            );
        },
        saveUserInterfacesTableConfig(config, cb) {
            this.uiConfig = config;
            this.uiCb = cb;
        },
    },
    created() {
        const promises = [
            SystemApi.services
                .getHierarchy()
                .then(r => {
                    this.hierarchy = r.data;
                    this.disableCurrentNode(this.hierarchy);
                })
                .catch(this.handleBackendError),
            SystemApi.security
                .getOperations()
                .then(r => this.operations = r.data)
                .catch(this.handleBackendError),
            i18nApi.getLanguages().then(r => {
                if (!this.service.translations) {
                    this.service.translations = {};
                }
                r.data.forEach(language => {
                    if (this.service.translations[language.code] === undefined) {
                        this.$set(this.service.translations, language.code, {title: '', description: '', technicalDescription: ''});
                    }
                });

                this.languages = r.data
            }),
        ];

        if (this.id) {
            promises.push(
                SystemApi.services
                    .card(this.id)
                    .then(r => this.service = r.data)
                    .catch(this.handleBackendError)
            );
            promises.push(
                SystemApi.services
                    .userInterfaces(this.id)
                    .then(r => {
                        this.userInterfaces = r.data;

                        if (this.uiCb) {
                            this.fetchUserInterfaces(this.uiConfig, this.uiCb);
                        }
                    })
            );
        }

        SystemApi.security
            .getUserInterfaces({}, {}, 1, 300)
            .then(r => this.allUserInterfaces = r.data.items);

        Promise.all(promises).then(() => this.showLoading = false);
    }
}
</script>

<style lang="css">
@import '../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.css';
</style>
